<ng-container *ngIf="shared.res">
  <p-toast position="top-right"></p-toast>
  <p-confirmDialog [header]="shared.res['#Confirm Action']" icon="pi pi-exclamation-triangle" [closable]="false" [closeOnEscape]="false"></p-confirmDialog>
  <div class="flex-row flex-grow" style="min-height:100%">
    <div class="flex-column flex-grow print:block">
      <div class="flex-row header print:hidden">
        <a class="header-logo print:u-mx-0" [routerLink]="['/']">
          <img style="width:100%" src="assets/circulate.svg" alt="circulate logo" />
        </a>
        <a class="header-menu print:hidden" [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <i class="pi pi-bars"></i>
        </a>
        <div class="header-center print:hidden">
          <router-outlet name="header" #headerOutlet="outlet"></router-outlet>
        </div>
        <div *ngIf="authInfoBehavior | async; let authInfo" class="header-right print:hidden">
          <div class="flex-column">
            <span style="vertical-align:middle">{{authInfo.userName}}</span>
            <div class="flex-row">
              <select [(ngModel)]="lang">
                <option *ngFor="let lang of proposedLanguages" [value]="lang">{{$any(shared.res.shared.lang)[lang]}}</option>
              </select>
              <a class="button" (click)="logOut()">{{shared.res['#Log out']}}</a>
            </div>
          </div>
          <img *ngIf="authInfo.imageId && authInfo.imageId.length > 0" alt="logo" [src]="'/api/file/image/' + authInfo.imageId" />
        </div>
      </div>
      <div class="workflow print:hidden">
        <router-outlet name="nav"></router-outlet>
      </div>
      <div class="u-m-2 print:u-m-0">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>
  </div>
</ng-container>


